
import {  Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";

import { search } from "../../../actions/courts";
import { deepEqual } from "../../../utils/object";

export default class CourtListSelect extends Component {
    constructor(props) {
        super(props);
        this.state = this.propsToState(props);
    }

    propsToState = (props) => {
        return {
            value: props.value
        }
    }

    doPostChange() {
        if (this.props.onChange) {
            this.props.onChange({
                target: {
                    name: this.props.name,
                    id: this.props.id,
                    value: this.state.value
                }
            })
        }
    }

    internalComponentDidUpdate(oldProps) {
        if ((this.props.value === oldProps.value) && (deepEqual(this.props.courts, oldProps.courts))) return;
        this.setState(this.propsToState(this.props));
    }

    componentDidUpdate = (oldProps) => {
        this.internalComponentDidUpdate(oldProps);
    }

    onChange = (e) => {
        if (this.state.value !== e?.value) {
            this.setState({ value: e?.value || "" }, this.doPostChange);
        }
    }

    get options() {
        const __result = [];
        (this.state.courts ?? this.props.courts)?.forEach(element => {
            __result.push({ value: element.uuid, label: `${element.full} (${element["Address.city"]}, ${element["Address.state"]})` });
        });
        return __result;
    }

    render() {
        return (
            <Select
                id={this.props.id}
                value={this.options.filter(option => option.value === this.state.value)}
                className={this.props.className}
                name={this.props.name}
                onChange={this.onChange}
                classNamePrefix="react-select"
                placeholder=""
                options={this.options}
                isClearable={true}
            >
            </Select>
        );
    }
}

class DataCourtListSelect extends CourtListSelect {
    constructor(props) {
        super(props);
    }


    loadData = async () => {
        const courts = await this.props.search({ size: -1, search: "" });
        this.setState({
            ...this.state,
            courts: [...courts.items]
        })
    }

    componentDidMount = async () => {
        await this.loadData();
    }
}

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};


export const ConnectedCourtList = connect(mapStateToProps, { search })(DataCourtListSelect);
